import store from '@/stores/messages/messages-store';
import { Message } from '@/stores/messages/messages-model';
import {
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

@Module({ dynamic: true, namespaced: true, name: 'MessagesModule', store })
class MessagesModule extends VuexModule {
  private _messages: Array<Message> = [];

  get currentMessage(): Message | null {
    if (this._messages.length === 0) {
      return null;
    }
    return this._messages[0];
  }

  get messageCount(): number {
    return this._messages.length;
  }

  @Mutation
  addMessage(message: Message) {
    this._messages.push(message);
  }

  @Mutation
  popMessage() {
    if (this._messages.length > 0) {
      this._messages.splice(0, 1);
    }
  }
}

export default getModule(MessagesModule);
